<script>
import * as user from '../user.js';
import * as utils from '../utils.js';
import { curUser } from '../user.js';
import { link, push, replace, querystring } from 'svelte-spa-router'
import { onMount } from 'svelte';
import qs from 'qs';
import Button from './button.svelte'
import Header from './header.svelte';

let email = '';
let password = '';

let pending = false; // true if we are waiting for login
let error = ''; // true if the login failed

let emailError = '';
let passwordError = '';

let signingIn = false;
$:signInButtonState = signingIn ? 'loading' : '';

/*
              {#if error === 'auth/wrong-password' || error === 'auth/user-not-found'}
                  <span class="error">Username or password incorrect. Please try again.</span>
              {:else}
                  <span class="error">Too many attempts. Please try again later</span>
              {/if}
            */


onMount(() =>
{

});

curUser.subscribe((u) =>
{
    if (u && u.auth)
    {
        const params = qs.parse($querystring);
        const rt = params.rt // (r)eturn (t)o

        // see if this user needs to reset their password
        if (u.forcePasswordReset)
        {
            replace('/reset?forced=1')
        }
        else
        {
            if (rt)
            {
                delete params['rt'];
                let path = rt;
                if (params)
                {
                    path += `?${qs.stringify(params)}`;
                }
                console.log('return route', path);
                replace(path);
            }
            else
            {
                replace('/');
            }
        }
    }
});


function SignIn()
{
    signingIn = true;
    passwordError = emailError = '';

    user.SignIn(email, password).then().catch(err =>
    {
        error = err.code;

        if (error === 'auth/wrong-password')
        {
            passwordError = 'Incorrect password. Please try again';
        }
        else if (error === 'auth/user-not-found' || error === 'auth/invalid-email')
        {
            emailError = 'Incorrect username or password. Please try again';
        }

        // not likely to need them all
        /*
        auth/invalid-credential
        auth/operation-not-allowed
        auth/user-disabled
        auth/invalid-verification-code
        auth/invalid-verification-id
        if (error.code === 'auth/account-exists-with-different-credential')
        {
            // this wont happen right now but might if we allow with with google, apple, etc
        }
        */
        utils.error('SignInError', error);
    })
    .then(() =>
    {
        signingIn = false;

    });
}

</script>

<Header/>

<div class="container main medium" style="padding-top: 2.5em;">
  <section>
    <header class="line-after">
        <h3>Sign In</h3>
    </header>
  </section>
  <section>

    <form on:submit|preventDefault={SignIn} novalidate>
      <div class="row gtr-uniform gtr-50">
        <div class="col-12 col-12-xsmall">
            <input class:error={emailError} placeholder="Email" type="email" bind:value={email} />
          {#if emailError}
            <div class="errorMsg">{emailError}</div>
          {/if}
        </div>
        <div class="col-12 col-12-xsmall">
            <input class:error={passwordError} placeholder="Password" type="password" bind:value={password} />
          {#if passwordError}
            <div class="errorMsg">{passwordError}</div>
          {/if}
        </div>
        <div class="col-12 col-12-xsmall">
          <ul class="actions special">
              <li>
                  <Button state={signInButtonState} class="button fit" text="SIGN IN"/>
              </li>
          </ul>
        </div>

    </form>
  </section>
<!--  <section style="text-align: right; margin-top: -1.5em; margin-bottom: 1.5em;">-->
<!--        <a href="/signin/help" use:link>Need help?</a>-->
<!--  </section>-->
<!--  <section>-->
<!--    <header>-->
<!--        <p>New to Summit Medical Institute? <a href="/signup/create" use:link><strong>Sign up now</strong></a></p>-->
<!--    </header>-->
<!--  </section>-->
</div>

<style>
ul
{
    padding-top:10px;
}

.error
{
    color: red;
}

li { width: 100%; }

input[value="Login"] {
  background-color: #1a242f !important;
  box-shadow: none;
  color: #fff !important;
  border: 1px solid #fff;
  width: 100%;
}

input {
  margin-bottom: 1.25em;
}

header.major { margin: 1em 0 0 0; }
header.line-after:after {
  content: '';
  display: inline-block;
  width: 6em;
  height: 0.25rem;
  margin: 0em 0 1.5em 0;
  border-radius: 4px;
  background-color: #4a98e2;
}

@media screen and (max-width: 480px) {
  .container > section.line-after:after {
    width: 100%;
    height: 0.25rem;
    margin: 1em 0;
  }
}

@media screen and (max-width: 736px) {
  .image > img {
    max-width: 90%;
    margin: 0 auto;
  }
}

form a
{
    color: rgb(103, 189, 255);
    border-bottom: 0;
}
.errorMsg
{
    color: red;
    text-align: left;
}

input.error
{
    border-color: red;
    border-width: 2px;
}

.container.medium.main {
  background-color: #1a242f !important;
  padding-top: 0;
  font-size: 13pt;
}

.container.medium.main input {
    background-color: rgb(0 0 0 / .3);
}

.container.medium.main h4, .container.medium.main h6, input, label, p, strong, h3 {
  color: #fff !important;
}

label {font-weight: 400;}

.container.medium.main {
  width: 500px;
  max-width: 500px;
}

@media screen and (max-width: 736px) {
  .container.medium.main {
    width: 425px;
  }
}

@media screen and (max-width: 480px) {
  .container.medium.main {
    width: 275px;
  }
}

@media screen and (max-width: 320px) {
  .container.medium.main {
    width: 250px;
  }
}


ul.actions.special >li { width: 100%; margin: 0;}


</style>
